import * as types from './index';


export const affiliateListAction = (data) => {
    return {
    type: types.AFFILIATES_LIST,
    data
    }
};


export const affiliateCompanyInfoAddAction = (data) => {
    return {
    type: types.AFFILIATE_COMPANYINFO_ADD,
    data
    }
};

export const affiliateEditAction = (data) => {
    return {
    type: types.AFFILIATE_EDIT,
    data
    }
};

export const affiliateCmnyInfoUpdateAction = (data) => {
    return {
    type: types.AFFILIATE_CMPNY_INFO_UPDATE,
    data
    }
};

export const affiliateAddressUpdateAction = (data) => {
    return {
    type: types.AFFILIATE_ADDRESS_UPDATE,
    data
    }
};

export const affiliatePrmryCntUpdateAction = (data) => {
    return {
    type: types.AFFILIATE_PRMRY_CNT_UPDATE,
    data
    }
};

export const affiliateSettingsUpdateAction = (data) => {
    return {
    type: types.AFFILIATE_SETTINGS_UPDATE,
    data
    }
};

export const affiliateDeleteAction = (data) => {
    return {
    type: types.AFFILIATE_DELETE,
    data
    }
};
